// React
import PropTypes from "prop-types";
import { useContext, useState } from "react";
// @mui material components
import { Card, Fade, Grid, Icon, InputLabel, Modal, Tooltip } from "@mui/material";

import { gql, useMutation } from "@apollo/client";
import ModalConfirm from "components/Modals/Confirm";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
import { formatDateARG, formatMoneyPunto } from "utils/formatters";
import { getUproColor } from "utils/colors";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "40%", sm: "30%", xxl: "30%" },
  overflowY: "auto",
};

const CARGAR_SALDO = gql`
  mutation cargarSaldoCliente($input: CargaSaldoInput!) {
    cargarSaldoCliente(input: $input)
  }
`;

export default function ModalAddCuenta({
  open,
  handleClose,
  refetch,
  cliente,
  tipo,
  refetchSaldoCCInfo,
}) {
  const { handleSnackbar } = useContext(MessageManager);
  const [datos, setDatos] = useState({
    total: null,
    descripcion: null,
  });

  const handleChange = (e) => {
    setDatos({
      ...datos,
      [e.target.name]: e.target.value,
    });
  };

  const [openConfirm, setOpenConfirm] = useState(false);
  const handleOpenConfirm = () => setOpenConfirm(true);
  const handleCloseConfirm = () => setOpenConfirm(false);

  const [cargarSaldoCliente, { loading: loadingPagar }] = useMutation(CARGAR_SALDO, {
    onCompleted: (data) => {
      handleCloseConfirm();
      handleClose();
      handleSnackbar("Se ha guardado correctamente", "success");
    },
    onError: (error) => {
      handleSnackbar(error.message, "error");
    },
  });

  const handleSave = () => {
    handleOpenConfirm();
  };

  const handleConfirm = () => {
    cargarSaldoCliente({
      variables: {
        input: {
          tipo: tipo,
          idCliente: cliente.id,
          total: parseFloat(datos.total),
          descripcion: datos.descripcion
        },
      },
    });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Fade }}
    >
      <Card sx={style}>
        <SoftBox p={3}>
          <SoftTypography variant="h5" fontWeight="medium">
            {tipo === "CargarSaldo" ? "Cargar saldo a cuenta corriente" : tipo === "BecarCliente" ? "Cargar beca a cliente" : "No se definió una acción"}
          </SoftTypography>
          <SoftBox mt={2} mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <InputLabel>
                  <SoftTypography variant="caption" fontWeight="bold" color={getUproColor("dark")}>
                    Descripción
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  type="text"
                  name="descripcion"
                  value={datos.descripcion}
                  onChange={handleChange}
                  placeholder="Descripción"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <InputLabel>
                  <SoftTypography variant="caption" fontWeight="bold" color={getUproColor("dark")}>
                    Total
                  </SoftTypography>
                </InputLabel>
                <SoftInputNumber
                  name="total"
                  value={datos.total}
                  onChange={handleChange}
                  placeholder="Total"
                  fullWidth
                />
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox display="flex" justifyContent="flex-end" alignItems="center" mt={3}>
            <SoftButton circular color="dark" onClick={() => handleClose()} sx={{ mr: 2 }}>
              Cancelar
            </SoftButton>
            <Tooltip title={"Guardar"} placement="top">
              <SoftButton
                circular
                color="primary"
                onClick={() => handleSave()}
                disabled={!datos.descripcion || !datos.total || loadingPagar}
              >
                {loadingPagar ? "Cargando..." : "Guardar"}
              </SoftButton>
            </Tooltip>
          </SoftBox>
        </SoftBox>

        {/* Modal Confirm */}
        <ModalConfirm
          open={openConfirm}
          handleClose={handleCloseConfirm}
          func={() => handleConfirm()}
          message={tipo === "CargarSaldo" ? "¿Está seguro de cargar saldo a cuenta corriente?" : tipo === "BecarCliente" ? "¿Está seguro de cargar beca a cliente?" : "No se definió una acción"}
        />
      </Card>
    </Modal>
  );
}

ModalAddCuenta.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetch: PropTypes.func,
  cliente: PropTypes.object,
  refetchSaldoCCInfo: PropTypes.func,
};
